import React from "react";
import { Header } from "../../../components/Header";
import "./styles.less";
import { Footer } from "../../../components/FooterV2";
import { SolutionIndustryCustomer } from "../../../blocks/solution-industry-customer";
import { SolutionIndustrySupport } from "../../../blocks/solution-industry-support";
import { CommonPageLink } from "../../../blocks/common-page-link";
import { HomeTryOn } from "../../../blocks/home-try-on";
import { useTranslation } from "react-i18next";
import { SolutionIndustryBanner } from "../../../blocks/solution-industry-banner";
import { SolutionSceneIntro } from "../../../blocks/solution-scene-intro";
import { BuildIdaasFeatures } from "../../../blocks/solution-build-idaas-features";
import { BuildIdaasFeaturesTable } from "../../../blocks/solution-build-idaas-features-table";
import { Helmet } from "react-helmet";
import { Notice } from "../../../components/Notice";

export const BuildIdaasPage = () => {
  const { t } = useTranslation();
  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];

  return (
    <div className="build-idaas-page">
      <Helmet>
        <title>构建企业专属身份云 IDaaS，企业单点登录系统-Authing 身份云</title>
      </Helmet>
      <Header mode="light" hasNotice />
      <SolutionIndustryBanner
        title={t("solution.buildIdaas.banner.title")}
        subtitle={t("solution.buildIdaas.banner.subtitle")}
        imgUrl="//files.authing.co/authing-website/solution-banner-build-idaas-v2.png"
        tagFrom="build-idaas"
      />
      {/* <SolutionIndustryCustomer /> */}
      <SolutionSceneIntro
        scene={
          <>
            <div className="item">
              {t("solution.buildIdaas.intro.descript1")}
            </div>
            <div className="item">
              {t("solution.buildIdaas.intro.descript2")}
            </div>
            <div className="item">
              {t("solution.buildIdaas.intro.descript3")}
            </div>
          </>
        }
      />
      <BuildIdaasFeatures />
      <BuildIdaasFeaturesTable />
      <SolutionIndustrySupport
        supportTitle={t("solution.scene.title-support")}
        noLastBlock
      />
      <CommonPageLink pagesLink={pagesLink} />
      <HomeTryOn hasBg />
      <Footer />
    </div>
  );
};
